import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './LoginPage.css'; // Custom CSS for additional styling

const Wallet = () => {
    const [balance, setBalance] = useState(0);
    const [loading, setLoading] = useState(true);
    const [showBalance, setShowBalance] = useState(true);

    useEffect(() => {
        const fetchWalletBalance = async () => {
            try {
                const userId = localStorage.getItem('userid');
                const response = await axios.get(`https://gtfundcrop.com/Rest5/wallet_api/${userId}`);
                setBalance(response.data.wallet || 0);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching wallet balance:", error);
                setLoading(false);
            }
        };

        fetchWalletBalance();
        
        // Refresh balance every 30 seconds
        const interval = setInterval(fetchWalletBalance, 30000);
        return () => clearInterval(interval);
    }, []);

    const formatBalance = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount).replace('₹', '₹');
    };

    return (
        <div className="wallet-container">
            <div className="wallet-card">
                <div className="wallet-header">
                    <h3>Wallet Balance</h3>
                    <button 
                        className="toggle-balance"
                        onClick={() => setShowBalance(!showBalance)}
                    >
                        <i className={`fa fa-eye${showBalance ? '' : '-slash'}`}></i>
                    </button>
                </div>
                
                <div className="wallet-balance">
                    {loading ? (
                        <div className="balance-loader">
                            <div className="spinner"></div>
                        </div>
                    ) : (
                        <>
                            {showBalance ? (
                                <h2 className="balance-amount">{formatBalance(balance)}</h2>
                            ) : (
                                <h2 className="balance-hidden">••••••</h2>
                            )}
                            <div className="balance-change">
                                <i className="fa fa-arrow-up"></i>
                                <span>0.00% today</span>
                            </div>
                        </>
                    )}
                </div>
                
                <div className="wallet-actions">
                    <Link to="/deposit" className="wallet-btn deposit">
                        <i className="fa fa-plus-circle"></i>
                        <span>Deposit</span>
                    </Link>
                    <Link to="/withdraw" className="wallet-btn withdraw">
                        <i className="fa fa-minus-circle"></i>
                        <span>Withdraw</span>
                    </Link>
                    <Link to="/transactions" className="wallet-btn history">
                        <i className="fa fa-history"></i>
                        <span>History</span>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Wallet;